$(document).ready(function() {
	if ($('#stream-player-fp')[0]) {
		var stream_args = {
			layoutControls: {
				primaryColor: '#b59a57',
				fillToContainer: true,
				doubleclickFullscreen: false,
				keyboardControl: true,
				allowDownload: false,
				allowTheatre: false
		},
			responsive: true
		};
		var player = fluidPlayer('stream-player-fp', stream_args);
	}
});